import { FC, useCallback } from 'react'
import { PageFooterButton } from 'components/atoms/buttons/PageFooterButton'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { activateAnchorActionCreator } from 'actions/navigationActions'
import { OPPORTUNITIES_PAGE } from 'constants/pages'

type ScrollToTopButtonProps = {
  type: typeof OPPORTUNITIES_PAGE
}

export const ScrollToTopButton: FC<ScrollToTopButtonProps> = (props) => {
  const { type } = props

  const dispatch = useStoreDispatch()
  const handleBackToTopClick = useCallback(() => {
    dispatch(activateAnchorActionCreator(type, {
      behavior: 'smooth',
    }))
  }, [dispatch, type])

  return (
    <PageFooterButton text='Scroll To First' onClick={ handleBackToTopClick } />
  )
}
